// extracted by css-extract-rspack-plugin
export default {"value":"_0YFs9zhnfQGQzqt","valuePrimary":"eiNhCxLwVKEBHQk0","tooltip":"W1PojzUFU3QrKqaM"};